class AccordionRow extends HTMLElement {
  constructor() {
    super();
    this.timeoutId = null;
    this.btn = this.querySelector('.accordion-btn');
    this.header = this.querySelector('.accordion-header');
    this.content = this.querySelector('.accordion-content');
    this.wrapper = this.querySelector('.accordion-wrapper');
    this.isOpen = false;
    this.header.addEventListener('click', () => {(this.toggleContent.bind(this))()});
    if (this.isOpen) this.open(false);
  }

  #toggleButton(){
    if (this.isOpen){
      this.btn.classList.add('open');
    } else {
      this.btn.classList.remove('open');
    }
  }

  #clearTransition(){
    this.timeoutId = setTimeout(() => {
      this.content.style.transition = 'none';
    }, 500)
  }

  #transitionHandler(withTransition){
    if (this.timeoutId) clearTimeout(this.timeoutId);
    if (withTransition) {
      this.content.style.transition = 'height .5s';
      this.#clearTransition();
    }
  }

  scrollToElementAndOpen() {
    this.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'center'});
    this.classList.add('with-focus')
    const focusHandler = (function () {
      this.wrapper.focus()
      this.open();
      this.wrapper.onblur = () => this.classList.remove('with-focus')
    }).bind(this)
    setTimeout(focusHandler, 800);
  }

  open(withTransition = true) {
    this.isOpen = true;
    this.#toggleButton();
    this.content.style.height = this.content.scrollHeight + 12 + 'px';
    this.#transitionHandler(withTransition);
  }

  close(withTransition = true) {
    this.isOpen = false;
    this.#toggleButton();
    this.content.style.height = '0px';
    this.#transitionHandler(withTransition);
  }

  toggleContent(){
    if (this.isOpen) this.close();
    else this.open();
  }
}
customElements.define('accordion-row', AccordionRow);
